import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

function Abstract() {
  return (
    <Container maxWidth="md" sx={{ margin: 4 }}>
      <Stack direction={{ xs: "column", md: "row" }} spacing={4}>
        <Stack>
          <Typography
            variant="h6"
            component="h2"
            sx={{ fontWeight: 600, textAlign: { xs: "left", md: "right" } }}
          >
            ABSTRACT
          </Typography>
        </Stack>
        <Stack>
          <Typography
            variant="body1"
            component="span"
            sx={{ textAlign: "justify" }}
          >
            Generative AI can create striking visuals from text, yet it struggles with a fundamental 
            aspect of human creativity: drawing inspiration from ambiguous forms. This interpretative 
            process, grounded in the cognitive phenomenon of pareidolia or divergent perception, 
            involves recognizing concepts in random shapes. To address this challenge, we present the 
            Silhouette-Enabled Expression with Meaningful Exploration (SEEME) framework that automates 
            this critical step, enabling creative generation directly from object silhouettes. Our 
            computational framework investigates two strategies, Visual-RAG and Semantic-RAG, to produce 
            diverse animal art interpretations that remain faithful to the input shape. We further introduce 
            a dataset of approximately 28,586 masked animal images to support continued research in this 
            direction. Both approaches are evaluated through a user study focusing on aesthetic quality 
            and shape fidelity. This work establishes a new pathway for perceptually grounded creative AI, 
            illustrating how machines can contribute not only to rendering but also to the initial act 
            of imaginative discovery.
          </Typography>
        </Stack>
      </Stack>
    </Container>
  );
}
export default Abstract;